import { Button, Flex } from "antd";
import { Divider } from "antd/lib";
import styled from "styled-components";

export const DividerStyled = styled(Divider)`
    margin: 16px 0;
    background-color: ${props => props.theme.features.administration.modalForm.dividerColor};
`;

export const FlexStyled = styled(Flex)`
    margin-top: 12px;
`;

export const SecondaryButton = styled(Button)`
    width: 100%;
    color: ${props => props.theme.features.administration.modalForm.secondaryButton.color};
    background-color: ${props => props.theme.features.administration.modalForm.secondaryButton.bgColor};
    border-color: transparent;
    
    &:hover, &:active {
        color: ${props => props.theme.features.administration.modalForm.secondaryButton.hoverColor} !important;
        border-color: ${props => props.theme.features.administration.modalForm.secondaryButton.hoverBorderColor} !important;
    }
`;
